var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerpoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.508,
    height: 13.774,
    viewBox: "0 0 11.508 13.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Powerpoint",
    d: "M10.179,11.762a3.455,3.455,0,1,0,3.455-3.455A3.455,3.455,0,0,0,10.179,11.762Zm3.455,2.5a2.5,2.5,0,0,1-.477-4.955v2.454a.477.477,0,0,0,.477.477h2.454a2.5,2.5,0,0,1-2.454,2.024Zm2.454-2.979H14.111V9.308A2.506,2.506,0,0,1,16.088,11.285Zm3.126-4.755L15.769,3.271a.063.063,0,0,0-.014-.012.5.5,0,0,0-.055-.045.44.44,0,0,0-.1-.055c-.021-.007-.045-.014-.067-.019h0a.391.391,0,0,0-.091-.01H9.788A1.911,1.911,0,0,0,7.88,5.038V15A1.911,1.911,0,0,0,9.788,16.9H17.48A1.911,1.911,0,0,0,19.388,15V6.9A.473.473,0,0,0,19.214,6.529ZM18.434,15a.954.954,0,0,1-.954.954H9.788A.954.954,0,0,1,8.834,15V5.038a.954.954,0,0,1,.954-.954h5.167V6.9a.479.479,0,0,0,.477.477h3Z",
    transform: "translate(-7.88 -3.13)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.c968e8e65bcd90b80eca612d95523e47.svg";
export { ForwardRef as ReactComponent };